// extracted by mini-css-extract-plugin
export default {"section":"XU7Fb","header":"terwN","headerText":"h8HaI","text":"FudyT","styles":"qq6VL","style":"SfE4M","styleCheck":"jMAY5","styleCheckIconWrapper":"INUGw","stylePreview":"zp2Tg"};